import React, { useState, useEffect, useMemo } from "react";
import {
  Modal, Box, Typography, TextField, Select, MenuItem, Button,
  IconButton, Divider, InputLabel, FormControl, GlobalStyles
} from "@mui/material";
import { useSelector } from 'react-redux';
import CloseIcon from "@mui/icons-material/Close";
import { Editor } from "@tinymce/tinymce-react";
import SingleSelectDropdown from "../../pages/SingleSelectDropdown";
import { developerTollApi } from "../../services/developerTollApi";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  maxHeight: "90dvh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "20px",
};

const AddUser = ({ openEditor, handleClose, selecteduser, users, userEdit, fetchUsers }) => {
  const [user, setUser] = useState("");
  const [role, setRole] = useState("");
  const [loader, setLoader] = useState(false);
  const { allUsers, loading, error } = useSelector((state) => state.meonUsers);

  const roleOptions = [
    { label: "OWNER", value: "OWNER" },
    { label: "ADMIN", value: "ADMIN" },
    { label: "USER", value: "USER" },
  ];

  useEffect(() => {
    if (selecteduser && openEditor && Array.isArray(allUsers?.data)) {
      setUser(selecteduser.email);
      setRole(selecteduser.role);
    }
    else
    {
      setUser("");
      setRole("");
    }

  }, [selecteduser, openEditor, allUsers]);

  const userOptions = allUsers?.data?.filter(user => {
    const isAlreadyAdded = users.some(added => added.email === user.emp_email);
    if (selecteduser && user.emp_email === selecteduser.email) return true;
    return !isAlreadyAdded;
  })
  .map(user => ({
    value: user.emp_email,
    label: user.emp_name
  }));

  const handleSave = async () => {
    const selectedUserObj = allUsers?.data?.find(
      (u) => u.emp_email === user
    );  
    console.log(selectedUserObj)
    const payload={
      name: selectedUserObj?.emp_name,
      email: selectedUserObj?.emp_email,
      role,
    }

    if (userEdit && selecteduser?.id) {
      payload.user_id = selecteduser.id;
    }
    handleClose();
    setLoader(true);
    try {
      let response;
      if (userEdit && selecteduser?.id) {
        response = await developerTollApi.updateUser(payload);
      } else {
        response = await developerTollApi.addUser(payload);
      }
      console.log(response)
      if(response?.status)
      {
        fetchUsers();
      }
    } catch (error) {
        console.error("Error fetching line chart data:", error);
    } finally {
        setLoader(false);
    }
  };

  return (
    <Modal open={openEditor} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p="20px 30px">
          <Typography sx={{ fontSize: '18px', fontWeight: 500, lineHeight: '20px', color: "#1D1D1D", paddingBottom: "2px" }}>Create User</Typography>
          <Box>
            <IconButton onClick={handleClose}><CloseIcon /></IconButton>
          </Box>
        </Box>

        <Divider />

        <Box sx={{ p: "20px 30px", overflow: "auto", maxHeight: "calc(100vh - 245px)" }}>
          <SingleSelectDropdown
              label={<Box sx={{ display: "flex", gap: 1}}>User</Box>}
              value={user}
              onChange={(val) => {console.log(val); setUser(val)}}
              options={userOptions}
              width="100%"
          />

          <SingleSelectDropdown
              label={<Box sx={{ display: "flex", gap: 1}}>Role</Box>}
              value={role}
              onChange={(val) => setRole(val)}
              options={roleOptions}
              width="100%"
              sx={{ mt: 2}}
          />
        </Box>

        <Divider mt="10px" />

        <Box display="flex" justifyContent="end" alignItems="center" p="20px 30px" gap="15px">
            <Button variant="contained" sx={{ width: '171px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={handleClose} >
                Cancel
            </Button>
            <Button variant="contained" sx={{ width: '171px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"}, "&:hover": {background: "#185CB7", color: "#ffffff", borderColor: "#185CB7"} }} onClick={handleSave} >
                {userEdit ? "Update" : "Save"}
            </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddUser;
